/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderTypeGroupOption
 */
export interface OrderTypeGroupOption {
    /**
     * 分组编码，仅在所属运费类型内生效
     * @type {number}
     * @memberof OrderTypeGroupOption
     */
    code?: number;
    /**
     * 分组中文名称
     * @type {string}
     * @memberof OrderTypeGroupOption
     */
    nameCn?: string;
    /**
     * 分组韩文名称
     * @type {string}
     * @memberof OrderTypeGroupOption
     */
    nameKr?: string;
    /**
     * 该分组包含的真实订单类型编码
     * @type {Array<number>}
     * @memberof OrderTypeGroupOption
     */
    orderTypes?: Array<number>;
}

/**
 * Check if a given object implements the OrderTypeGroupOption interface.
 */
export function instanceOfOrderTypeGroupOption(value: object): value is OrderTypeGroupOption {
    return true;
}

export function OrderTypeGroupOptionFromJSON(json: any): OrderTypeGroupOption {
    return OrderTypeGroupOptionFromJSONTyped(json, false);
}

export function OrderTypeGroupOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderTypeGroupOption {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'orderTypes': json['orderTypes'] == null ? undefined : json['orderTypes'],
    };
}

export function OrderTypeGroupOptionToJSON(json: any): OrderTypeGroupOption {
    return OrderTypeGroupOptionToJSONTyped(json, false);
}

export function OrderTypeGroupOptionToJSONTyped(value?: OrderTypeGroupOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'nameCn': value['nameCn'],
        'nameKr': value['nameKr'],
        'orderTypes': value['orderTypes'],
    };
}

